import { ImagesEmpty40 } from '@cian/ui-kit/prev';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { TChatImageFile } from '../../../types/imageFile';
import { ChatImageLoader } from '../../ChatImageLoader';

interface IUserCardImageProps {
  src: string;
  image: TChatImageFile;
  onLoad: () => void;
  onError: () => void;
  onClick: () => void;
  isLoading: boolean;
  isError: boolean;
}

const UserCardImageComponent = function (
  { src, image, onLoad, onError, onClick, isLoading, isError }: IUserCardImageProps,
  ref: React.Ref<HTMLImageElement>,
) {
  const { name } = image;

  return (
    <div data-testid="UserCardImage" className={classNames(styles['container'])} onClick={onClick}>
      <span className={styles['loader']} data-testid="loader">
        <ChatImageLoader isLoading={isLoading} />
      </span>
      {isError && (
        <div className={styles['error']} data-testid="error">
          <ImagesEmpty40 color="current_color" />
        </div>
      )}
      <img
        ref={ref}
        className={styles['image']}
        src={src}
        alt={name}
        loading="lazy"
        onLoad={onLoad}
        onError={onError}
      />
    </div>
  );
};

export const UserCardImage = React.forwardRef(UserCardImageComponent);
